module.exports = __webpack_public_path__ + "img/202006.4738b8c6.png";